import React from 'react'
import styled from 'styled-components'

import { Margins, Colors } from '../../constants'

const WarningContainer = styled.div`
  padding: ${Margins.s}px ${Margins.m}px;
  border: 1px solid #3e65da;
  box-sizing: border-box;
  border-radius: 20px;
`

const WarningText = styled.p`
  color: ${Colors.WHITE};
  font-size: 1rem;
  line-height: 1.5rem;
`

export const Warning = ({
  warningText,
}: {
  warningText: React.ReactChild | string
}) => {
  return (
    <WarningContainer>
      <WarningText>{warningText}</WarningText>
    </WarningContainer>
  )
}
